import { Component, OnInit } from "@angular/core";

import { BulkServicesService } from "../../../../core/api/services";
import { Bulk2ServicesService } from "../../../../core/api/services/bulk-2-services.service";
import { DialogService } from "../../../../core/services/dialog.service";
import { FileService } from "../../../../core/services/file.service";
import { MobileNumbersService } from "../../../../core/services/mobile-numbers.service";
import { UtilityService } from "../../../../core/services/utility.service";
import { BulkNumbersDeleteFromXlsxComponent } from "../../bulk-number-information/bulk-number-delete-from-xlsx/bulk-numbers-delete-from-xlsx.component";
import { BaseFormModule } from "src/app/pages/shared/base/modules/base-form.module";

@Component({
    selector: "app-bulk-numbers-delete-from-xlsx2",
    templateUrl: "./bulk-numbers-delete-from-xlsx2.component.html",
    styleUrls: ["./bulk-numbers-delete-from-xlsx2.component.scss"],
    imports: [BaseFormModule]
})
export class BulkNumbersDeleteFromXlsx2Component
  extends BulkNumbersDeleteFromXlsxComponent
  implements OnInit
{
  pageVocabs = "pages.bulkNumberInformation.form.";
  exelTypes: string[] = ["xls", "xlsx", "csv"];

  constructor(
    protected bulkService: BulkServicesService,
    protected bulk2Service: Bulk2ServicesService,
    protected dialogService: DialogService,
    protected fileService: FileService,
    protected mobileNumbersService: MobileNumbersService,
    protected UtilityService: UtilityService
  ) {
    super(
      bulkService,
      dialogService,
      fileService,
      mobileNumbersService,
      UtilityService
    );
  }
}
